// Investigation for manual enrolment

import reducer, { initialState } from '../../reducers/passkeyFlow';
import * as actions from '../../actions/passkeyFlow';

const fn = { reducer, initialState, actions };
export default fn;
